import React from 'react';
import styles from './AppInfo.module.css';
import infoSign from '../../assets/images/Info-sign.png';
import classnames from 'classnames';
import useCheckMobileScreen from '../../hooks/useCheckMobileScreen';
import { useTranslation } from 'react-i18next';

interface IAppInfo {
  showMobileReservationInputFlag?: boolean;
}

const AppInfo = ({ showMobileReservationInputFlag }: IAppInfo) => {
  const { t } = useTranslation();
  const appInfoContainerDiv = classnames(styles.appInfoContainer, {
    [styles.appInfoContainerDiv]: useCheckMobileScreen() && showMobileReservationInputFlag
  });
  return (
    <>
      <div className={appInfoContainerDiv} data-testid={'appInfoDivTestId'}>
        <img className={styles.infoSign} src={infoSign} alt={'Info sign'} />
        <div>
          <span>
            <strong>{t('message_header')}</strong>
          </span>
          <p className={styles.alertInfo}>{t('partner_app_info_content')}</p>
        </div>
      </div>
    </>
  );
};

export default AppInfo;
